<template>
  <svg xmlns="http://www.w3.org/2000/svg" height="100%" viewBox="0 0 10.536 11.372">
    <g transform="translate(-73.504 -735.314)">
      <rect width="8" height="2" rx="1" transform="translate(80.575 736.728) rotate(135)" />
      <rect data-name="line" width="8" height="2" rx="1" transform="translate(74.918 739.615) rotate(45)" />
      <rect data-name="line" width="8" height="2" rx="1" transform="translate(84.04 741.85) rotate(180)" />
    </g>
  </svg>
</template>
<script>
export default {
  name: "M4ArrowLeftSvg"
};
</script>
